import React, { useState, useEffect } from 'react';
import './App.css';
import WorkshopsSection from './components/WorkshopsSection';

const Home = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    'Zimowisko Enklawy to jedyne takie wielodniowe zimowe wydarzenie, które gromadzi społeczność cyrkową w atmosferze pasji i inspiracji. Łączy warsztaty, pokazy i konkursy z budowaniem relacji i wymianą doświadczeń między uczestnikami. To nie tylko festiwal, ale przestrzeń do integracji, rozwoju i tworzenia wyjątkowej społeczności kuglarskiej. To Enklawa.',
    'W planach m.in.: warsztaty, Open Stage, Fire Space, Igrzyska Żonglerskie, Turniej Domów, trening 24/7, a przede wszystkim świetna zabawa i niezapomniane wspomnienia!',
    'Standardowo do Waszej dyspozycji zapewniamy nocleg w udostępnionych przez nas klasach i korytarzach, łazienki z prysznicami, stołówkę z czajnikami i herbatą oraz hale sportowe do ćwiczeń dostępne 24/7.',
  ];

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      setIsScrolled(scrollPosition > window.innerHeight * 0.8);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const elements = document.querySelectorAll('.animate-on-scroll');
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15 }
    );
    elements.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [currentSlide, slides.length]);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  };

  return (
    <div className="App">
      {/* Sticky Navigation Bar */}
      <header
        className={`fixed top-0 w-full z-50 py-4 px-8 flex justify-between items-center transition-colors duration-300 ${
          isScrolled ? 'bg-blue-900 text-white' : 'bg-transparent text-white'
        }`}
      >
        <a href="#hero">
          <img src="/logo.png" alt="Logo" className="h-12" />
        </a>

        <button
          type="button"
          className="text-white text-2xl md:hidden"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          aria-label="Otwórz menu"
        >
          ☰
        </button>

        <nav
          className={`overflow-hidden md:overflow-visible transition-all duration-300 md:flex md:space-x-4 absolute md:static top-16 left-0 w-full md:w-auto md:max-h-none md:opacity-100 ${
            isMenuOpen ? 'max-h-60 opacity-100' : 'max-h-0 opacity-0'
          } ${isScrolled ? 'bg-blue-900' : 'bg-transparent'} text-center md:text-left`}
        >
          <a
            href="#about"
            className="block md:inline hover:underline py-2 md:py-0"
            onClick={() => setIsMenuOpen(false)}
          >
            O Zimowisku
          </a>
          <a
            href="#workshops"
            className="block md:inline hover:underline py-2 md:py-0"
            onClick={() => setIsMenuOpen(false)}
          >
            Warsztaty
          </a>
          <a
            href="#location"
            className="block md:inline hover:underline py-2 md:py-0"
            onClick={() => setIsMenuOpen(false)}
          >
            Lokalizacja
          </a>
          <a
            href="#contact"
            className="block md:inline hover:underline py-2 md:py-0"
            onClick={() => setIsMenuOpen(false)}
          >
            Kontakt
          </a>
          <a
            href="https://linktr.ee/zimowiskoenklawy"
            target="_blank"
            rel="noopener noreferrer"
            className="block md:inline hover:underline py-2 md:py-0"
            onClick={() => setIsMenuOpen(false)}
          >
            Wszystkie potrzebne linki
          </a>
        </nav>
      </header>

      {/* Hero Section */}
      <section
        id="hero"
        className="bg-blue-900 text-white h-screen flex flex-col justify-center items-center relative"
      >
        <img
          src="/hero.png"
          alt="Hero Banner"
          className="absolute inset-0 w-full h-full object-cover opacity-80"
        />
        <div className="relative z-10 text-center">
          <h1 className="text-5xl font-bold">VI Zimowisko Enklawy</h1>
          <p className="text-2xl mt-2">22 - 25.01.2026</p>
          <p className="text-2xl mt-2">
            Zespół Szkół Techniczno-Informatycznych w Elbląg
          </p>
          <a
            href="https://forms.gle/Vs1ZkWWBNzo4Ti6F8"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block mt-8 px-8 py-3 bg-white text-blue-900 font-bold text-lg rounded-full hover:bg-blue-100 transition-colors duration-200 shadow-lg"
          >
            Zarejestruj się
          </a>
        </div>
      </section>

      {/* About Section with Carousel */}
      <section
        id="about"
        className="bg-gray-100 text-blue-900 py-16 px-8 text-center"
      >
        <h2 className="text-3xl font-bold mb-4">O Zimowisku</h2>
        <div className="relative max-w-2xl mx-auto animate-on-scroll">
          <p key={currentSlide} className="text-xl carousel-text">{slides[currentSlide]}</p>
          <div className="flex justify-center gap-2 mt-6">
            {slides.map((_, i) => (
              <button
                key={i}
                type="button"
                onClick={() => setCurrentSlide(i)}
                aria-label={`Przejdź do slajdu ${i + 1}`}
                className={`w-3 h-3 rounded-full transition-colors ${
                  i === currentSlide ? 'bg-blue-900' : 'bg-blue-900/30'
                }`}
              />
            ))}
          </div>
          <div className="flex justify-between mt-4">
            <button
              type="button"
              className="bg-blue-900 text-white px-4 py-2 rounded hover:bg-blue-700"
              onClick={prevSlide}
              aria-label="Poprzedni slajd"
            >
              ◀
            </button>
            <button
              type="button"
              className="bg-blue-900 text-white px-4 py-2 rounded hover:bg-blue-700"
              onClick={nextSlide}
              aria-label="Następny slajd"
            >
              ▶
            </button>
          </div>
        </div>
      </section>

      {/* Workshops Section (grid + modal) */}
      <WorkshopsSection />

      {/* Location Section */}
      <section
        id="location"
        className="bg-gray-200 text-blue-900 py-16 px-8 text-center"
      >
        <h2 className="text-3xl font-bold mb-4">Lokalizacja</h2>
        <div className="map-container animate-on-scroll">
          <iframe
            title="Google Map"
            src="https://www.google.com/maps/d/u/2/embed?mid=1KdL1AOcJlPle2EiB3AsQ0pn6VwtB2QI&ehbc=2E312F"
            width="100%"
            height="400"
            className="border-0 mx-auto"
            allowFullScreen=""
            loading="lazy"
          ></iframe>
        </div>
      </section>

      {/* Contact Section */}
      <section
        id="contact"
        className="bg-blue-900 text-white py-16 px-8 text-center"
      >
        <h2 className="text-2xl font-bold mb-4">Kontakt</h2>
        <a className="mb-2" href="mailto:kontakt@festiwalenklawa.pl">
          kontakt@festiwalenklawa.pl
        </a>
        <p>
          <a href="tel:505627896">Wojciech: 505 627 896</a>
        </p>
        <p>
          <a href="tel:722396821">Artur: 722 396 821</a>
        </p>
        <p>
          <a href="tel:506942621">Kasia: 506 942 621</a>
        </p>
      </section>

      {/* Footer */}
      <footer className="bg-blue-800 text-white py-4 px-8 text-center">
        <p className="mb-2">
          &copy; 2026 Fundacja Exodus. Wszelkie prawa zastrzeżone.
        </p>
      </footer>
    </div>
  );
};

export default Home;
